import React, { FC } from 'react';
import { Cancel } from '@mui/icons-material';
import { Dialog, IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import API from 'api/API';
import Theme from 'App.theme';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import * as Styles from './AddSerialNumberModal.styles';

interface SerialNumberBelongsToDifferentSetModalProps {
  open: boolean;
  close: () => void;
  setUUID: string | null;
  errorMessage: string;
  setCode: string;
  serialNumber: string;
}

const SerialNumberBelongsToDifferentSetModal: FC<SerialNumberBelongsToDifferentSetModalProps> = ({
  open,
  close,
  setUUID,
  errorMessage,
  setCode,
  serialNumber,
}) => {
  const [language] = useLanguage();

  const handleConfirm = async (): Promise<void> => {
    try {
      await API.UssEndpoint.addSerialNumber({ set_code: setUUID || '', new_uss: serialNumber, move_uss: true });
      toast.success(language.ManageSerialNumbers.Modal.success);
    } catch (error) {
      API.errorHandler(error);
    }
    close();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth={'lg'} fullWidth={false}>
      <Styles.Container>
        <IconButton sx={{ position: 'absolute', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        <h2>{language.ManageSerialNumbers.addSerialNumber}</h2>
        <div style={{ textAlign: 'center', color: Theme.status.REJECTED, paddingTop: '20px' }}>{errorMessage}</div>
        <div style={{ textAlign: 'center', paddingTop: '20px' }}>
          <span>{language.ManageSerialNumbers.Modal.proceedStartText}</span>
          <span>{setCode}</span>
          <span>{language.ManageSerialNumbers.Modal.proceedEndText}</span>
        </div>
        <div style={{ textAlign: 'center', paddingTop: '20px' }}>
          {language.ManageSerialNumbers.Modal.proceedActionWarning}
        </div>
        <Button onClick={handleConfirm} style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          {language.ManageSerialNumbers.Modal.submit}
        </Button>
        <Button onClick={() => close()} style={{ position: 'absolute', bottom: '1rem', left: '1rem' }}>
          {language.ManageSerialNumbers.Modal.cancel}
        </Button>
      </Styles.Container>
    </Dialog>
  );
};

export default SerialNumberBelongsToDifferentSetModal;
